export const PROJECT_MILESTONES = {
  'requirement-gathering': {
    key: 'requirement-gathering',
    label: 'Requirement Gathering & Analysis',
    description: 'Collect business needs and objectives from stakeholders. Identify scope, constraints, and success metrics. Conduct feasibility studies (technical, operational, financial).',
    outputs: ['Business Requirement Document (BRD)', 'Functional Requirement Specification (FRS)'],
    color: '#ff4d4f',
    order: 1
  },
  'planning': {
    key: 'planning',
    label: 'Planning',
    description: 'Define project scope, deliverables, timeline, and budget. Identify resources (team, tools, infra). Risk assessment and mitigation strategies.',
    outputs: ['Project Plan', 'Work Breakdown Structure (WBS)'],
    color: '#fa8c16',
    order: 2
  },
  'system-design': {
    key: 'system-design',
    label: 'System Design',
    description: 'High-level design (HLD): architecture, technology stack, modules, data flow. Low-level design (LLD): detailed workflows, database schema, UI/UX wireframes, API contracts.',
    outputs: ['Design Documents', 'Prototypes/Wireframes'],
    color: '#fadb14',
    order: 3
  },
  'development': {
    key: 'development',
    label: 'Development (Coding)',
    description: 'Developers write code based on LLD. Setup version control (Git), coding standards, and environments. Unit testing of individual components.',
    outputs: ['Source Code', 'Build Versions'],
    color: '#1890ff',
    order: 4
  },
  'testing-qa': {
    key: 'testing-qa',
    label: 'Testing & Quality Assurance',
    description: 'Functional testing, Integration testing, Regression testing, Performance testing, Security testing, User Acceptance Testing (UAT). Defect reporting and fixing.',
    outputs: ['Test Cases', 'Test Reports', 'UAT Sign-off'],
    color: '#722ed1',
    order: 5
  },
  'deployment-prep': {
    key: 'deployment-prep',
    label: 'Deployment / Go-Live Preparation',
    description: 'Setup production environment (cloud/on-prem). Data migration (if applicable). Final round of testing (smoke test, sanity test).',
    outputs: ['Deployment Plan', 'Release Notes'],
    color: '#13c2c2',
    order: 6
  },
  'go-live': {
    key: 'go-live',
    label: 'Go-Live',
    description: 'Actual rollout to production. System made available to end-users. Monitoring system health post-deployment.',
    outputs: ['Live Production System'],
    color: '#52c41a',
    order: 7
  },
  'post-live-support': {
    key: 'post-live-support',
    label: 'Post-Go-Live Support & Maintenance',
    description: 'Handle user feedback, bug fixes, patches. Performance monitoring and optimization. Regular updates, feature enhancements, security upgrades.',
    outputs: ['Support Logs', 'Maintenance Reports'],
    color: '#eb2f96',
    order: 8
  }
};

export const MILESTONE_OPTIONS = Object.values(PROJECT_MILESTONES).sort((a, b) => a.order - b.order);

export const getMilestoneColor = (milestone) => {
  return PROJECT_MILESTONES[milestone]?.color || '#d9d9d9';
};

export const getMilestoneLabel = (milestone) => {
  return PROJECT_MILESTONES[milestone]?.label || milestone;
};

export const getMilestoneDescription = (milestone) => {
  return PROJECT_MILESTONES[milestone]?.description || '';
};

export const getMilestoneOutputs = (milestone) => {
  return PROJECT_MILESTONES[milestone]?.outputs || [];
};
